import { COINBASE, METAMASK, RAINBOW, ZERION, } from "../../../wallets/constants.js";
import { createWallet } from "../../../wallets/create-wallet.js";
/**
 * @internal
 */
export function getDefaultWallets(options) {
    return [
        createWallet("inApp"),
        createWallet(METAMASK),
        createWallet(COINBASE, {
            appMetadata: options?.appMetadata,
            chains: options?.chains,
        }),
        createWallet(RAINBOW),
        createWallet("io.rabby"),
        createWallet(ZERION),
    ];
}
//# sourceMappingURL=defaultWallets.js.map